import LazyWrapper from '@/common/LasyWrapper';
import React from 'react';
import { RouteObject } from 'react-router-dom';
import ExamCenter from './ExamPortal';

const ExamAdd = React.lazy(() => import('./ExamAdd'));
const ImportScore = React.lazy(() => import('./pages/importScore/ImportScore'));
const ImportExcel = React.lazy(() => import('@/pages/common/importExcel/ImportExcel'));
const ReportSetting = React.lazy(() => import('./pages/reportSetting/ReportSetting'));
const ExamAbsence = React.lazy(() => import('./pages/absence/ExamAbsence'));
const SchoolAbsence = React.lazy(() => import('./pages/absence/schools/SchoolAbsence'));
const ModifyHistory = React.lazy(() => import('./pages/modifyScore/ModifyHistory'));
const ExamPublish = React.lazy(() => import('./pages/publish/ExamPulish'));
const ImportedScorePreview = React.lazy(() => import('./pages/importScore/ImportedScorePreview'));
const SchoolImportedPreview = React.lazy(() => import('./pages/importScore/SchoolImportedPreview'));
const MarkApply = React.lazy(() => import('./pages/absence/apply/Apply'));
const BatchImportScore = React.lazy(() => import('./pages/importScore/BatchImportScore'));
const PreMark = React.lazy(() => import('./pages/absence/preMark/PreMark'));

const router: RouteObject[] = [
  {
    path: 'examCenter',
    element: <ExamCenter></ExamCenter>
  },
  {
    path: 'examCenter/examAdd',
    element: <LazyWrapper><ExamAdd></ExamAdd></LazyWrapper>
  },
  {
    path: 'examCenter/examEdit',
    element: <LazyWrapper><ExamAdd></ExamAdd></LazyWrapper>
  },
  {
    path: 'examCenter/examAbsence',
    element: <LazyWrapper><ExamAbsence></ExamAbsence></LazyWrapper>
  },
  {
    path: 'examCenter/examAbsence/schoolDimension/:schoolId',
    element: <LazyWrapper><SchoolAbsence></SchoolAbsence></LazyWrapper>
  },
  {
    path: 'examCenter/examAbsence/:schoolId',
    element: <LazyWrapper><SchoolAbsence></SchoolAbsence></LazyWrapper>
  },
  {
    path: 'examCenter/examAbsence/:schoolId/apply',
    element: <LazyWrapper><MarkApply></MarkApply></LazyWrapper>
  },
  {
    path: 'examCenter/examAbsence/applyReview',
    element: <LazyWrapper><MarkApply></MarkApply></LazyWrapper>
  },
  {
    path: 'examCenter/:examCourseId',
    element: <LazyWrapper><ImportedScorePreview></ImportedScorePreview></LazyWrapper>
  },
  // 批量导入小题得分
  {
    path: 'examCenter/:examCourseId/batchimportscore',
    element: <LazyWrapper><BatchImportScore /></LazyWrapper>
  },
  // 导入分数
  {
    path: 'examCenter/:examCourseId/:course',
    element: <LazyWrapper><ImportScore></ImportScore></LazyWrapper>
  },
  {
    path: 'examCenter/:examName/:course/import',
    element: <LazyWrapper><ImportExcel></ImportExcel></LazyWrapper>
  },
  {
    path: 'examCenter/reportSetting',
    element: <LazyWrapper><ReportSetting></ReportSetting></LazyWrapper>
  },
  {
    path: 'examCenter/modifyHistory',
    element: <LazyWrapper><ModifyHistory></ModifyHistory></LazyWrapper>
  },
  {
    path: 'examCenter/publish',
    element: <LazyWrapper><ExamPublish></ExamPublish></LazyWrapper>
  },
  // 各校导入概览
  {
    path: 'examCenter/schoolImportedPreview',
    element: <LazyWrapper><SchoolImportedPreview></SchoolImportedPreview></LazyWrapper>
  },
  // 缺考预登记
  {
    path: 'examCenter/examAbsence/:schoolId/preMark',
    element: <LazyWrapper><PreMark></PreMark></LazyWrapper>
  }
];

export default router;
